<template>
  <BaseSidebar
    :show-back-button="true"
    :back-text="'Cerrar'"
    @close="handleClose"
    @back="handleClose"
  >
    <ProviderForm 
      :handleRequestInitData="handleRequestInitData" 
      :closeModal="handleClose" 
      :provider="provider" 
      :show-details="showDetails"
      :overlayService="overlayService"
    />
  </BaseSidebar>
</template>

<script>
import { i18n } from "@/i18n";
import BaseSidebar from '@/components/overlays/BaseSidebar.vue';
import ProviderForm from './ProviderForm.vue';

export default {
  name: 'ProviderFormSidebar',
  components: {
    BaseSidebar,
    ProviderForm
  },
  props: {
    provider: {
      type: Object,
      default: null
    },
    showDetails: {
      type: Boolean,
      default: false
    },
    handleRequestInitData: {
      type: Function,
      required: true
    },
    overlayService: {
      type: Object,
      default: null
    }
  },
  emits: ['close'],
  data() {
    return {
      isDirty: false
    };
  },
  mounted() {
    this.setupCloseInterception();
    this.setupFormWatching();
  },
  beforeUnmount() {
    this.removeCloseInterception();
  },
  methods: {
    handleClose() {
      if (this.isDirty) {
        if (confirm(i18n.global.t("provider.auto.estas_seguro_de_que_deseas_cerrar_los_cambios_no"))) {
          this.$emit('close');
        }
      } else {
        this.$emit('close');
      }
    },
    setupFormWatching() {
      this.$nextTick(() => {
        const sidebar = this.$el;
        if (sidebar) {
          sidebar.addEventListener('input', () => this.isDirty = true);
          sidebar.addEventListener('change', () => this.isDirty = true);
        }
      });
    },
    setupCloseInterception() {
      this.escapeHandler = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
          if (this.isDirty) {
            if (confirm(i18n.global.t("provider.auto.estas_seguro_de_que_deseas_cerrar_los_cambios_no"))) {
              this.$emit('close');
            }
          } else {
            this.$emit('close');
          }
        }
      };
      document.addEventListener('keydown', this.escapeHandler, true);
      
      setTimeout(() => {
        const backdrop = document.querySelector('.overlay-backdrop');
        if (backdrop) {
          this.backdropHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.isDirty) {
              if (confirm(i18n.global.t("provider.auto.estas_seguro_de_que_deseas_cerrar_los_cambios_no"))) {
                this.$emit('close');
              }
            } else {
              this.$emit('close');
            }
          };
          backdrop.addEventListener('click', this.backdropHandler, true);
        }
      }, 100);
    },
    removeCloseInterception() {
      if (this.escapeHandler) {
        document.removeEventListener('keydown', this.escapeHandler, true);
      }
      if (this.backdropHandler) {
        const backdrop = document.querySelector('.overlay-backdrop');
        if (backdrop) {
          backdrop.removeEventListener('click', this.backdropHandler, true);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>